import { db } from "../../../config/firebaseconfig";
import uuid from 'uuid/v1'

export default function addNewAccount(state, parentAccount, accountType) {

  const collections = {
    'District': 'districts',
    'School': 'schools',
    'Class': 'classes',
  }
  const parentCollections = {
    'School': 'districts',
    'Class': 'educators' 
  }
  let parentRef
  const id = uuid()
  const time = Date.now()
  const batch = db.batch()
  const ref = db.collection(collections[accountType]).doc(id)
  if (parentCollections[accountType]) {
    parentRef = db.collection(parentCollections[accountType]).doc(parentAccount.id)
  }

  // add new account to batch 
  let newAccount = {
    id,
    name: state.name,
    accountType,
    created: time,
    lastModified: time,
    groupType: accountType,
  }
  if (accountType === 'District') {
    newAccount.districtResults = {}
    newAccount.schools = {}
    newAccount.state = state.state
    newAccount.admins = {}
    newAccount.sfid = state.sfid ? state.sfid : ''
  } else if (accountType === 'School') {
    newAccount.schoolResults = {}
    newAccount.students = {}
    newAccount.teachers = {}
    newAccount.district = parentAccount.id
    newAccount.state = parentAccount.state
    newAccount.admins = {}
    newAccount.sfid = state.sfid ? state.sfid : ''
  } else if (accountType === 'Class') {
    newAccount.district = parentAccount.schoolDistrict
    newAccount.school = parentAccount.school
    newAccount.teacher = parentAccount.id
    newAccount.period = state.period ? state.period : state.name
    newAccount.state = parentAccount.state,
    newAccount.students = {},
    newAccount.schoolYear = '2018'
  }
  batch.set(ref, newAccount)

  // add parent update to batch if has parentAccount
  if (parentRef) {
    const parentKey = `${collections[accountType]}.${id}`
    batch.update(parentRef, {[parentKey]: true, lastModified: time})
  }

  return batch.commit()
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/addNewAccount.js